import type { PropsWithChildren } from 'react'
import React from 'react'
import Typography from '../Typography/Typography'

function Label({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  return <Typography variant="subtitle2">{children}</Typography>
}

export default Label
